module.exports = __webpack_public_path__ + "img/niño61.f9d06d86.jpg";